import { Description } from '@mui/icons-material';
import { Box, Chip, Stack } from '@mui/material';
import { CuriosityNamespaceType, CuriosityValue } from '@procureai/curiosity-ui-mui';
import { ReactNode } from 'react';
import { Streamdown } from 'streamdown';

import { components, allowedTags } from '../../../ChatMessage/MessageRenderer/MessageRenderer.config.tsx';
import { ChatUserMessageProps } from '../../ChatUserMessage.tsx';

import { useChatUserFileAttachmentMessage } from './ChatUserFileAttachmentMessage.hook.ts';

export const ChatUserFileAttachmentMessage = ({ message }: ChatUserMessageProps): ReactNode => {
  const parsedData = useChatUserFileAttachmentMessage(message);

  return (
    <Box
      sx={(theme) => ({ backgroundColor: theme.palette.grey[200], padding: 3, borderRadius: 2, alignSelf: 'flex-end' })}
    >
      <Box sx={{ maxWidth: 'md' }}>
        <Streamdown mode="static" components={components} allowedTags={allowedTags}>
          {parsedData.content}
        </Streamdown>
        {parsedData.files && parsedData.files.length > 0 && (
          <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: 'wrap', gap: 1 }}>
            {parsedData.files.map(({ fileId, fileName }) => (
              <Chip
                key={fileId}
                icon={<Description />}
                label={fileName || <CuriosityValue i18nKey={fileId} ns={CuriosityNamespaceType.FILE} />}
                variant="outlined"
                sx={(theme) => ({
                  maxWidth: 200,
                  backgroundColor: theme.palette.background.paper,
                  borderColor: theme.palette.divider,
                })}
              />
            ))}
          </Stack>
        )}
      </Box>
    </Box>
  );
};
